<template>
    <div class="list">

    <div class="itemList">
    
        <h1 class="topTitle">商品一覧</h1>
        <div class="container" >
            <div class="outer-menu">
                <input class="checkbox-toggle" v-model="isShowSerchBox" type="checkbox"/>
                
                <div class="hamburger" :class="{ searchIcon: !isShowSerchBox}" @click="isShowSerchBox = !isShowSerchBox" >
                    <div v-if="isShowSerchBox"></div>
                </div>
                <div class="menu">
                    <div class="searchArea">
                        <div class="searchBox">
                            <h2 class="itemTitle">検索</h2> 
                            <ul>
                                <li>
                                    <label for="itemName">カテゴリ:</label>
                                    <select class="sltBox" v-model="serchItem.category">
                                        <option value="" disabled selected hidden>選択してください</option>
                                        <option v-for="item in categoryList" :value="item.ID" :key="item.ID">
                                            {{ item.CATEGORY_NAME }}
                                        </option>
                                    </select>
                                </li>
                            <li>
                                <label for="itemName">商品名:</label>
                                <input type="text" placeholder="商品名" id="itemName" v-model="serchItem.name" tabindex="1"/>
                            </li>
                            <li>
                                <label for="itemMemo">備考:</label>
                                <input type="text" placeholder="備考" id="itemMemo" v-model="serchItem.memo" tabindex="1"/>
                            </li>
                            
                            <li class="serchDateBox">
                                <label for="price">販売価格:</label>
                                <input class="searchDate" type="number" placeholder="販売価格（FROM）" id="price" v-model="serchItem.itemPriceStr" tabindex="2"/> ~ 
                                <input class="searchDate" type="number" placeholder="販売価格（TO）" v-model="serchItem.itemPriceEnd" tabindex="2"/>
                            </li>
                            <li class="serchDateBox">
                                <label for="str">登録日時:</label>
                                <datepicker
                                    v-model="serchItem.createDateStr"
                                    format="yyyy年MM月dd日"
                                    placeholder="登録日（FROM）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                                ~
                                <datepicker
                                    v-model="serchItem.createDateEnd"
                                    format="yyyy年MM月dd日"
                                    placeholder="登録日（TO）"
                                    input-class="searchDate"
                                    :language="ja"
                                    :disabled-dates="disabledDates"></datepicker>
                            </li>
                        </ul>
                        <div class="btnBox">
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, clear()">クリア</button>
                            <button class="btn" @click="isShowSerchBox = !isShowSerchBox, serch()">検索</button>
                        </div>
                        </div>
                        
                        
                        
                    </div>
                </div>
            </div>
            <div class="other_btn">
                <button class="btn" style="
                width: 200px;
                margin: 10px 0;
                background-color: #403af3;
                border: none;"
                @click="show_categry"
                >
                    カテゴリ設定
                </button>
            </div>
            <div class="other_btn">
                <button class="btn" style="
                width: 200px;
                margin: 10px 0;
                /* background-color: #403af3; */
                border: none;"
                @click="is_discount_setting=!is_discount_setting"
                >
                    販売価格一括設定
                </button>
            </div>
            <div v-show="is_discount_setting">
                <div class="brdBtm">
                    <h3 id="discountPrice" class="itemLable">出品マイナス額</h3>
                    <div class="minText">入力した金額を販売価格から引きます。※足したい場合は-を入力してください。</div>
                    <input class="input-2" type="number" v-model="discount_obj.price" >
                    <p class="unit">円</p>
                </div>
                <div class="">
                    <button class="btn" @click="allUpdateDiscount" >設定する</button>
                </div>
            </div>
            <div>
                <p><span>総商品種類(在庫0はカウント無):{{ tmpItemList.filter(x=> x.STOCK_QUANITY > 0).length }}種類</span></p>
                <span>総在庫数:{{ tmpItemList.filter(x=> x.STOCK_QUANITY > 0).map(x=> Number(x.STOCK_QUANITY)).reduce((sum, element) => sum + element, 0)  }}個</span>
            </div>
            <div class="pdgTop10">
                    <vuejs-paginate
                        :page-count="getPaginateCount"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :click-handler="paginateClickCallback"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :first-last-button="true"
                        :first-button-text="'<<'"
                        :last-button-text="'>>'"
                        :force-page="currentPage"
                    ></vuejs-paginate>
                </div>
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle btnB">
                            変更
                        </th>
                        <th class="listTitle">
                            商品画像
                        </th>
                        <th class="listTitle">
                            商品名
                        </th>
                        <th class="listTitle">
                            カテゴリ(Sellers内)
                        </th>
                        <th class="listTitle">
                            販売価格
                        </th>
                        <th class="listTitle">
                            値引価格
                        </th>
                        <!-- <th class="listTitle">
                            値引回数
                        </th> -->
                        <th class="listTitle">
                            登録日時
                        </th>
                        <th class="listTitle">
                            在庫数
                        </th>
                        <th class="listTitle">
                            備考
                        </th>
                        
                    </tr>
                    
                    <tr v-for="(item , index) in getItems" :key="item.ITEM_ID" >
                        <td class="listItem">
                            <div class="remBox"><span class="remText">この行の商品が<br>削除されます</span><button class="btn remove" @click="remove(item, index + ((currentPage -1) *  perPage))">削除</button></div>
                            <div class="updBox"><span class="updText">この行の商品を<br>左の内容に更新します</span><button class="btn upd" @click="change(index + ((currentPage -1) *  perPage))">更新</button></div>
                            <div class="modifBox"><span class="modifText">商品登録ページへ<br>遷移します</span><button class="btn modif" @click="modif(item)">変更</button></div>
                        </td>
                        <td class="listItem center imgF">
                            <img v-show ="item.TMP_IMG != null" class="itemImg" :src="item.TMP_IMG">
                            <img v-show ="item.TMP_IMG == null" class="itemImg" src="../assets/noimage.jpg">
                        </td>
                        <td class="listItem">
                            {{item.ITEM_TITLE}}
                        </td>
                        <td class="listItem">
                            <select class="sltBox" v-model="item.R_CATEGORY">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in categoryList" :value="item.ID" :key="item.ID">
                                    {{ item.CATEGORY_NAME }}
                                </option>
                            </select>
                        </td>
                        <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].ITEM_PRICE.errMsg" :key="err">{{ err }}</div>
                            <input type="text" v-model="item.ITEM_PRICE" @input="valid($v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].ITEM_PRICE, '販売価格')"><p class="unit">円</p>
                        </td>
                        <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].DISCOUNT_PRICE.errMsg" :key="err">{{ err }}</div>
                            <input type="text" v-model="item.DISCOUNT_PRICE" @input="valid($v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].DISCOUNT_PRICE, '値引価格')">円
                        </td>
                        <!-- <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].DISCOUNT_NUM.errMsg" :key="err">{{ err }}</div>
                            <input type="text" v-model="item.DISCOUNT_NUM" @input="valid($v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].DISCOUNT_NUM, '値引回数')">回
                        </td> -->
                        <td class="listItem">
                            {{item.CREATE_DAY}}
                        </td>
                        <td class="listItem">
                            <div class='validErrMsg' v-for="(err) in $v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].STOCK_QUANITY.errMsg" :key="err">{{ err }}</div>
                            <input type="text" v-model="item.STOCK_QUANITY" @input="valid($v.tmpItemList.$each[index + ((currentPage -1) *  perPage)].STOCK_QUANITY, '在庫数')">個
                        </td>
                        <td class="listItem">
                            
                            <textarea v-model="item.MEMO"></textarea>
                        </td>
                        
                        
                    </tr>
                    <div class="none">
                        <input type="text" v-model="tmp">
                    </div>
                    
                    
                </table>
                <div class="">
                    <button class="btn" @click="allUpdate" >商品一括更新</button>
                </div>

                <div class="overlay" v-show="isShowCategoryBox">
                    <div class="createModal" style="height: 80%;">
                        <div
                        class="swal2-popup swal2-modal swal2-show"
                        style="display: grid;height: 100%;"
                        >
                        <div class="login">
                            <div class="login_form_top">
                            <h1 class="title">カテゴリ管理</h1>
                            </div>
                            <div class="formBox" style="height: 40%;overflow-y: scroll;">
                                <ul>
                                    <li v-for="category in categoryList">
                                        <div>
                                            <input type="text" style="width: 50%;" v-model="category.CATEGORY_NAME">
                                            <button @click="deleteCategory(category.ID)" 
                                            style="
                                                width: 15%;
                                                margin: 5px;
                                                height: 40px;
                                                background-color: red;
                                                border: none;
                                                border-radius: 5px;
                                            ">削除</button>
                                            <button @click="upsertCategry(category)"
                                            style="
                                                width: 15%;
                                                margin: 5px;
                                                height: 40px;
                                                background-color: aqua;
                                                border: none;
                                                border-radius: 5px;
                                            ">更新</button>
                                        </div>
                                        
                                    </li>
                                </ul>
                            
<!--                             
                            <div class="btnBox">
                                <button class="btn repage" @click="isModal = !isModal">
                                キャンセル
                                </button>
                                <button class="btn" @click="create">作成</button>
                            </div> -->
                            </div>
                            <div style="margin: 10px;">
                                <h3>新規カテゴリ作成</h3>
                            
                                <input type="text" v-model="newCategory.CATEGORY_NAME">
                                <div class="btnBox">
                                    <button class="btn repage" @click="show_categry">
                                    キャンセル
                                    </button>
                                    <button class="btn" @click="upsertCategry(newCategory)">作成</button>
                                </div>
                                
                            </div>
                            
                        </div>
                        </div>
                    </div>
                    </div>

                <div class="pdgTop10">
                    <vuejs-paginate
                        :page-count="getPaginateCount"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :click-handler="paginateClickCallback"
                        :container-class="'pagination justify-content-center'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :first-last-button="true"
                        :first-button-text="'<<'"
                        :last-button-text="'>>'"
                        :force-page="currentPage"
                    ></vuejs-paginate>
                </div>
            </div>
            <input type="hidden" v-model="tmp">
            <!-- <div class="btnBox subArea">
                <button class="btn repage" @click="returnPage">戻る</button>
                <button class="btn submit" @click="newRegister" >商品登録</button>
            </div> -->

            
            <div class="btnBox subArea">
                <button class="btn submit" @click="newRegister" >商品登録</button>
                <button class="btn repage" @click="returnPage">戻る</button>
            </div>

        </div>
    </div>
    </div>
</template>
<script>
import {itemRepository} from '@/Repositories/itemRepository.js'
import {cApiRepsitory} from '@/Repositories/cApiRepsitory.js'
import VueJsPaginate from 'vuejs-paginate';
import Datepicker from 'vuejs-datepicker';
import {ja} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';
import check from '@/common/commonCheck';
import { required, maxLength, maxValue, minValue} from "vuelidate/lib/validators";



export default {
    
  data() {
        return {
            /******************
             * Datepicker設定
            ******************/
            ja:ja,

            disabledDates:{
                from:new Date()
            },
            userInfo:'',
            isShowSerchBox:false,
            isShowCategoryBox:false,
            is_discount_setting: false,
            discount_obj:{

            },
            itemList:[],
            tmpItemList:[],
            categoryList:[],
            newCategory:{
                ID:0
            },
            tmp:'',
            serchItem : {
                name:null,
                itemPrice:null,
                createDateStr:null,
                createDateEnd:null
            },
            currentPage: 1,
            perPage: 20
        }
  },
    components: {
        "vuejs-paginate": VueJsPaginate,
        Datepicker,
    },
  methods:{
    allUpdateDiscount(){
        let vm = this;
        var tmpItemList = [...vm.itemList];
        var ids = tmpItemList.map(x=> x.ITEM_ID).join('\',\'');;
        vm.discount_obj.ids = ids;
        vm.discount_obj.type = 'discount_setting';
        cApiRepsitory.methods.post(vm.discount_obj).then(res=>{
            this.$swal("更新しました", {
                icon: "success",
            });
        })
    },
    show_categry(){
        let vm = this;
        vm.isShowCategoryBox = !vm.isShowCategoryBox;
    },
    getCategory(){
        cApiRepsitory.methods.post({
            "user_id":this.userInfo.USER_ID,
            "type":'getCategory'
        }).then(res=>{
            this.categoryList = res.data;
        })
    },
    upsertCategry(item){
        console.log(item);
        cApiRepsitory.methods.post({
            "id":item.ID,
            "user_id":this.userInfo.USER_ID,
            "category_name":item.CATEGORY_NAME,
            "type":'setCategory'
        }).then(res=>{
            this.$swal("更新しました", {
                icon: "success",
            });
            this.newCategory = {ID:0}
            this.getCategory();
        })
    },
    deleteCategory(id){
        cApiRepsitory.methods.post({
            "id":id,
            "type":'deleteCategory'
        }).then(res=>{
            this.$swal("削除しました", {
                icon: "success",
            });
            this.categoryList = this.categoryList.filter(x=> x.ID != id);
        })
    },
    allUpdate(){
        let vm = this;
        let start = (vm.currentPage - 1) * vm.perPage;
        let end = vm.currentPage * vm.perPage;
        var tmp = vm.tmpItemList.slice(start, end);
        cApiRepsitory.methods.post({
            "items":tmp,
            "type":'updateAllItem'
        }).then(res=>{
            this.$swal("更新しました", {
                icon: "success",
            });
        })

    },
      serch(){
        let vm = this;
        this.currentPage = 1;
        var tmpItemList = [...vm.itemList];
        if(vm.serchItem.category){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.R_CATEGORY == vm.serchItem.category;
            });
        }
        
        if(vm.serchItem.name){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.ITEM_TITLE.indexOf(vm.serchItem.name) != -1;
            });
        }
        if(vm.serchItem.memo){
            //名前フィルター
            tmpItemList = tmpItemList.filter(function(item) {
                return item.MEMO != null && item.MEMO.indexOf(vm.serchItem.memo) != -1;
            });
        }
        if(vm.serchItem.itemPriceStr){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.ITEM_PRICE) >= Number(vm.serchItem.itemPriceStr) 
            });
        }
        if(vm.serchItem.itemPriceEnd){
            //存在チェック
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.ITEM_PRICE) <= Number(vm.serchItem.itemPriceEnd) ;
            });
        }
        if(vm.serchItem.createDateStr){
            //存在チェック
            var str= moment(vm.serchItem.createDateStr).format('YYYYMMDD');
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.CREATE_DAY) >= Number(str) 
            });
        }
        if(vm.serchItem.createDateEnd){
            //存在チェック
            var end= moment(vm.serchItem.createDateEnd).format('YYYYMMDD');
            tmpItemList = tmpItemList.filter(function(item) {
                return Number(item.CREATE_DAY) <= Number(end) ;
            });
        }
        vm.tmpItemList = tmpItemList;
    },
    clear(){
        this.tmpItemList = [...this.itemList];
        this.serchItem ={};
    },
    paginateClickCallback (pageNum) {
        this.currentPage = Number(pageNum);
    },
    remove(item, index){
        let vm = this;
        this.$swal({
        title: "この商品を削除してよろしいですか？",
        text: `商品名:${item.ITEM_TITLE}`,
        icon: "warning",
        showCancelButton: true,
        reverseButtons : true
        }).then((btn) => {
            if (btn.isConfirmed) { 
                item.ITEM_TITLE = null;
                itemRepository.methods.register(item)
                .then(res=>{
                    vm.itemList.splice(index,1);
                    this.$swal("削除しました", {
                        icon: "success",
                    });
                })
            }
        });
      },
      change(index){
          let vm =this;
          var item = vm.tmpItemList[index];
          if(!vm.chgUserValidAll(vm.$v.tmpItemList.$each[index])) return;
          vm.$functions.swAlert(vm, "warning", "この商品を更新してよろしいですか？",`商品名:${item.ITEM_TITLE}`)
           .then((btn) => {
            if (btn.isConfirmed) {
                item.FLG = true;
                itemRepository.methods.register(item)
                .then(res=>{
                    this.$swal("更新しました", {
                        icon: "success",
                    });
                })
            }
        });
          
      },
      chgUserValidAll(item){
            let vm = this;
            try{
                
                if(!check.checkStr(item.ITEM_PRICE, '販売価格'))  throw 'userName';
                if(!check.checkStr(item.DISCOUNT_PRICE, '値引価格')) throw 'userId';
                if(!check.checkStr(item.DISCOUNT_NUM, '値引回数')) throw 'userId';
                if(!check.checkStr(item.STOCK_QUANITY, '在庫数')) throw 'userId';
            }catch(e){
                console.log(e);
                vm.tmp = 'tmp';
                return false;
            }
            return true;
        },
      modif(item){
          let vm =this;
          var id = item.ITEM_ID.split('_');
          var pageNum = 
          vm.$router.push(`/registerItem/${id[id.length -1]}/${this.currentPage}`)
      },
      newRegister(){
        let vm =this;
        vm.$router.push(`/registerItem/0/${this.currentPage}`)
      },
      returnPage(){
          let vm = this;
            vm.$router.back();
        },
        valid(v, name, regexType){
            check.checkStr(v, name, regexType);
        },
  },
  computed:{
        getPaginateCount: function () {
            return Math.ceil(this.tmpItemList.length / this.perPage);
        },
        getItems () {
            if(this.itemList.length == 0) return;
            let start = (this.currentPage - 1) * this.perPage;
            let end = this.currentPage * this.perPage;
            return this.tmpItemList.slice(start, end);
        }
    },
  created:function(){
      let vm =this;
      var pageNum = vm.$route.params.pageNum;
      if(!pageNum)pageNum = 1;
      itemRepository.methods.getAll()
      .then(res=>{
          vm.itemList = res.data; 
          vm.tmpItemList = res.data;
          vm.paginateClickCallback(pageNum);
      })
      .catch(err=>{
          console.log(err);
      });
      vm.userInfo = vm.$functions.getSStorage("userInfo");
      vm.getCategory();
  },
  validations: {
      tmpItemList:{
          $each:{
              ITEM_PRICE:{
                  required,
                  err:(val)=> check.HankakuSuuzi(val),
                  minValue: minValue(0),
                  maxValue: maxValue(2000000),
                  $param: 'HankakuSuuzi'
              },
              DISCOUNT_PRICE:{
                  required,
                  err:(val)=> check.HankakuSuuzi(val),
                  minValue:minValue(0),
              },
              DISCOUNT_NUM:{
                  required,
                  err:(val)=> check.HankakuSuuzi(val),
                  maxValue: maxValue(3),
                  minValue:minValue(0),
              },
              STOCK_QUANITY:{
                  required,
                  err:(val)=> check.HankakuSuuzi(val),
                  minValue:minValue(0),
              }
          }
      }
  }
}
</script>

<style lang="scss">
    
</style>